// src/store/hooks/useAuthInit.ts
import { useEffect } from "react";
import { useAuthStore } from "@/store";

/**
 * Initializes auth on app load:
 * - If valid tokens exist, validates the session via GET /me and refreshes the store user
 *   (the persisted user snapshot is only a fallback; App shows the full-screen loader
 *   until /me resolves, because /me is the source of truth).
 * - Without tokens, /me is skipped and the store is reset.
 * - `isInitializing` stays true until /me resolves or fails.
 * `initializeSession` is single-flight, so React StrictMode's double effect only fetches once.
 */
export function useAuthInit() {
  const initializeSession = useAuthStore((state) => state.initializeSession);
  const isInitializing = useAuthStore((state) => state.isInitializing);

  useEffect(() => {
    void initializeSession();
  }, [initializeSession]);

  return { isInitializing };
}
